import { View, Text } from "@react-pdf/renderer";

export function PatientSection({
  name,
  accountNumber,
}: {
  name: string;
  accountNumber?: string;
}) {
  return (
    <View
      style={{ display: "flex", flexDirection: "row", marginTop: 10, gap: 4 }}
    >
      <View style={{ width: "50%", display: "flex", flexDirection: "column" }}>
        <Text style={{ fontSize: 12, fontFamily: "Helvetica-Bold" }}>
          A. Notifier:
        </Text>
        <Text style={{ fontSize: 12, fontFamily: "Helvetica-Bold" }}>
          B. Patient Name: {name}
        </Text>
      </View>
      <View style={{ width: "50%", display: "flex", flexDirection: "column" }}>
        <Text
          style={{ fontSize: 12, fontFamily: "Helvetica-Bold", height: 13 }}
        />
        <Text style={{ fontSize: 12, fontFamily: "Helvetica-Bold" }}>
          C. Identification Number: {accountNumber}
        </Text>
      </View>
    </View>
  );
}
